export const DATE_PICKER_DATE_FORMAT = 'MMMM DD, YYYY'

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
export const SERVER_TIME_FORMAT = 'HH:mm:ss'

export const DATE_FORMAT_WITH_SLASH = 'DD/MM/YYYY'

export const DATE_TIME_FORMAT = 'DD MMMM YYYY - h:mm A'

export const DATE_TIME_FORMAT_WITH_COMMA = 'DD MMMM YYYY, h:mm A'

export const DATE_TIME_WITH_COMMA_FORMAT = 'DD MMM YYYY, h:mm A'

export const SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const USER_READABLE_DATE_FORMAT = 'dd MMM ‘yy'

export const DEFAULT_TIME_FORMAT = 'HH:mm:ss'

export const HOME_PAGE_DATE_TIME_FORMAT = 'DD MMM YYYY '

export const HOME_PAGE_SINGLE_DATE_TIME_FORMAT = 'D MMM YYYY '

export const READABLE_DATE_TIME_FORMAT = 'DD MMM YYYY - hh:mm A'

export const DELIVERABLE_CARD_DATE_TIME_FORMAT = READABLE_DATE_TIME_FORMAT

export const DATE_FORMAT_DATE_RANGE_PICKER = 'MMM DD YYYY'

export const TIME_FORMAT = 'hh:mm A'

export const DELIVERABLE_MONTH_FORMAT = 'MMMM YYYY'

export const DAY_IN_MILLISECONDS = 86400000

export const HOUR_IN_MILLISECONDS = 3600000

export const MINUTE_IN_MILLISECONDS = 60000

export const DUE_DATE_FORMAT = 'DD MMM YY - hh:mm A'

export const DATE_TIME_WITH_HYPHEN_FORMAT = 'D MMMM YYYY - hh:mm A'

export const DUE_DATE_SAME_YEAR_FORMAT = 'DD MMM - hh:mm A'

export const MONTH_DATE_FORMAT = 'DD MMM'

export const DATE_NUMBERS_WITH_HYPHEN_FORMAT = 'DD-MM-YYYY'

export const MONTH_DATE_TIME_FORMAT = 'MMM DD, YYYY h:mm A'

export const DAY_AND_MONTH_FOCUSSED_FORMAT = 'DD MMM,YYYY-hh:mm A'

export const DEFAULT_DATE_FORMAT = 'DD MMMM YYYY'

export const DEFAULT_DATE_TIME_FORMAT = 'DD MMMM YYYY - hh:mm A'

export const DATE_AND_TIME_WITH_DIVIDER = 'DD-MM-YYYY | hh:mm A'

export const READABLE_DATE_TIME_FORMAT_WITH_COMMA_SEPARATION =
   'DD MMM YY, hh:mm A'

export const READABLE_DATE_AND_TIME_WITH_DIVIDER = 'DD MMM YYYY | hh:mm A'

export const DATE_WITH_HYPHEN_FORMAT = 'DD-MMM-YYYY'

export const DEFAULT_DATE_FORMAT_COMMAN_SEPARATED = 'DD MMMM,YYYY'
